import { useEffect, useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { Spinner } from '@klaro7/ui';

import { fetchCallRecordingBlob } from './api';

/**
 * Fetches the call recording as an authenticated blob and plays it with a
 * native <audio> element. Object URL is revoked on unmount/blob change.
 */
export function CallRecordingPlayer({ callId }: { callId: string }) {
  const {
    data: blob,
    isLoading,
    isError,
  } = useQuery({
    queryKey: ['revenue', 'call', callId, 'recording'],
    queryFn: () => fetchCallRecordingBlob(callId),
    staleTime: Infinity,
    retry: 1,
  });

  const [url, setUrl] = useState<string | null>(null);
  useEffect(() => {
    if (!blob) return undefined;
    const objectUrl = URL.createObjectURL(blob);
    setUrl(objectUrl);
    return () => URL.revokeObjectURL(objectUrl);
  }, [blob]);

  if (isLoading) {
    return (
      <div className="flex items-center gap-2 py-2 text-sm text-neutral-400">
        <Spinner size="sm" /> Caricamento registrazione…
      </div>
    );
  }
  if (isError || !url) {
    return <p className="py-2 text-sm text-red-600">Impossibile caricare la registrazione.</p>;
  }
  return <audio controls src={url} className="w-full" preload="metadata" />;
}
